import React from 'react';
import styled from 'styled-components';
import AppShell from './AppShell';

const Wrap = styled.div`
  padding: 16px;
  padding-left: calc(16px + var(--safe-left));
  padding-right: calc(16px + var(--safe-right));
`;

const Card = styled.div`
  background: var(--tg-surface);
  border: 1px solid var(--tg-border);
  border-radius: var(--tg-radius);
  box-shadow: var(--tg-shadow);
  padding: 16px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 800;
`;

const Sub = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: var(--tg-muted);
  line-height: 1.6;
`;

const Calls = () => {
  return (
    <AppShell title="تماس">
      <Wrap>
        <Card>
          <Title>تماس‌ها</Title>
          <Sub>
            این بخش برای نمایش تاریخچه تماس و شروع تماس مستقیم است. در قدم بعدی می‌توانیم
            آن را به سیستم تماس ۱-به-۱ یا تماس روم‌ها وصل کنیم.
          </Sub>
        </Card>
      </Wrap>
    </AppShell>
  );
};

export default Calls;
